import { useNavigate } from "react-router-dom";
import { cities as cityData } from "@/mocks/cityData";

const relatedServices = [
  "Plumbing", "HVAC", "Landscaping", "Roofing", "Electrical", "Painting",
  "Pressure Washing", "Gutter Cleaning", "Pest Control", "Concrete",
];

const extraCities = [
  { label: "Atlanta, GA", href: "/service-areas" },
  { label: "Austin, TX", href: "/service-areas" },
  { label: "Portland, OR", href: "/service-areas" },
  { label: "Las Vegas, NV", href: "/service-areas" },
  { label: "San Antonio, TX", href: "/service-areas" },
  { label: "Sacramento, CA", href: "/service-areas" },
  { label: "Orlando, FL", href: "/service-areas" },
  { label: "Charlotte, NC", href: "/service-areas" },
];

const states = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
  "Connecticut", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois",
  "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine",
  "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
  "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Tennessee", "Texas",
  "Utah", "Virginia", "Washington", "Wisconsin",
];

export default function ServiceAreaLinks() {
  const navigate = useNavigate();

  const linkedCities = cityData.map((c) => ({
    label: `${c.city}, ${c.stateCode}`,
    href: `/tree-service/${c.slug}`,
  }));

  const allCities = [...linkedCities, ...extraCities];

  return (
    <section className="bg-white py-14 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Find pros for other jobs */}
        <div className="mb-12">
          <h3 className="text-base font-bold text-[#1B4332] mb-4">Find Pros for Other Jobs Nearby</h3>
          <div className="flex flex-wrap gap-2">
            {relatedServices.map((svc) => (
              <a
                key={svc}
                href="/free-quote"
                onClick={(e) => { e.preventDefault(); navigate("/free-quote"); }}
                className="text-sm text-[#1B4332] bg-[#E8F5E9] hover:bg-[#1B4332] hover:text-white px-3 py-1.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                {svc}
              </a>
            ))}
          </div>
        </div>

        {/* Find tree service in your city */}
        <div className="mb-12">
          <h3 className="text-base font-bold text-[#1B4332] mb-4">Find Tree Service Pros in Your City</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-4 gap-y-2">
            {allCities.map((city) => (
              <a
                key={city.label}
                href={city.href}
                onClick={(e) => { e.preventDefault(); navigate(city.href); }}
                className="text-sm text-[#1B4332] hover:underline cursor-pointer whitespace-nowrap"
              >
                {city.label}
              </a>
            ))}
          </div>
        </div>

        {/* Find tree service in your state */}
        <div>
          <h3 className="text-base font-bold text-[#1B4332] mb-4">Find Tree Service Pros in Your State</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-4 gap-y-2">
            {states.map((state) => (
              <a
                key={state}
                href="/service-areas"
                onClick={(e) => { e.preventDefault(); navigate("/service-areas"); }}
                className="text-sm text-[#1B4332] hover:underline cursor-pointer whitespace-nowrap"
              >
                {state}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
